<!--
 * @Descripttion:
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2020-07-06 12:17:06
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @LastEditTime: 2023-05-22 19:10:31
-->
<!-- 页面底部 -->
<template>
  <div v-html="fHtml" class="lb-footer"></div>
</template>

<script>
export default {
  data () {
    return {
      fHtml: 'DXV-9151-RGWU-0100-TUFH-3320-RFCY-95843P'
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.lb-footer {
  width: 100%;
  height: 49px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  background: #fff;
  position: fixed;
  bottom: -1000px;
  left: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue